<template>
  <div :data-testid="getTestId('admin-company-managers-page')">
    <CompanyManagerCrudTable :data-testid="getTestId('admin-company-managers-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'CompanyManagers',
  components: {
    CompanyManagerCrudTable: () => import('../../components/table/CompanyManagerCrudTable')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>

<style scoped>
.v-card {
  margin: 16px;
}
</style>
